"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrowthLoyaltyBehavior = void 0;
const api_1 = require("../growth/api");
const errors_1 = require("../growth/errors");
const external_1 = require("./external");
/**
 * Blaze Growth, reached through the same loyalty gateway as other external providers
 * but with enrollment and tiers on top.
 */
class GrowthLoyaltyBehavior extends external_1.ExternalLoyaltyBehavior {
    constructor() {
        super(...arguments);
        this.capabilities = {
            usesProviderPoints: true,
            showsInternalLoyaltyData: false,
            supportsEnrollment: true,
            supportsPointsRetry: true,
            // Growth points are informational, and its display replaces the platform's.
            contributesPointsToPayment: false,
            isSoleLoyaltyDisplay: true,
        };
    }
    loadCustomerLoyalty(customer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // A successful profile response means the customer is enrolled.
                const profile = yield (0, api_1.getGrowthCustomerProfile)({
                    gatewayUrl: this.context.getGatewayUrl(),
                    merchantId: this.context.getMerchantId(),
                    customer,
                });
                return { status: 'enrolled', points: profile.availablePoints, tier: profile.tier };
            }
            catch (error) {
                // A coded 400 is a successful determination, not a failure.
                if ((0, errors_1.isNotEnrolledError)(error)) {
                    return { status: 'notEnrolled' };
                }
                return { status: 'error', message: 'Failed to load loyalty profile' };
            }
        });
    }
    enrollCustomer(customerId, enrollment) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, api_1.enrollGrowthCustomer)({
                gatewayUrl: this.context.getGatewayUrl(),
                merchantId: this.context.getMerchantId(),
                customerId,
                enrollment,
            });
        });
    }
    unenrollCustomer(customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, api_1.unenrollGrowthCustomer)({
                gatewayUrl: this.context.getGatewayUrl(),
                merchantId: this.context.getMerchantId(),
                customerId,
            });
        });
    }
}
exports.GrowthLoyaltyBehavior = GrowthLoyaltyBehavior;
//# sourceMappingURL=growth.js.map